import type { IconNode } from '../types';

/**
 * @name dome
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjF2LTNhMiAyIDAgMDE0IDB2MyIgLz4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xOCAxMnY5IiAvPgogIDxwYXRoIGQ9Ik0yMiAxOWEyIDIgMCAwMS0yIDJINGEyIDIgMCAwMS0yLTJ2LTZhMSAxIDAgMDExLTFoMThhMSAxIDAgMDExIDF6IiAvPgogIDxwYXRoIGQ9Ik00IDEyYTggOCAwIDAxMTYgMCIgLz4KICA8cGF0aCBkPSJNNiAxMnY5IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/dome
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Dome: IconNode = [
  ['path', { d: 'M10 21v-3a2 2 0 014 0v3' }],
  ['path', { d: 'M12 2v2' }],
  ['path', { d: 'M18 12v9' }],
  ['path', { d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a1 1 0 011-1h18a1 1 0 011 1z' }],
  ['path', { d: 'M4 12a8 8 0 0116 0' }],
  ['path', { d: 'M6 12v9' }],
];

export default Dome;
